import React, { useState } from 'react';

import { Alert, Button } from '@mui/material';

interface FallbackRenderProps {
  error: unknown;
  resetErrorBoundary: () => void;
}

const FallbackRender: React.FC<FallbackRenderProps> = ({
  error,
  resetErrorBoundary: _resetErrorBoundary,
}) => {
  const [showStack, setShowStack] = useState(false);

  // Type guard to check if error is an Error object
  const errorMessage = error instanceof Error ? error.message : String(error);
  const errorStack = error instanceof Error ? error.stack : undefined;

  return (
    <Alert
      severity="error"
      sx={{
        height: 'min-content',
      }}
    >
      <p>Something went wrong: {errorMessage}</p>
      {errorStack && (
        <>
          <Button variant="text" onClick={() => setShowStack(!showStack)}>
            {showStack ? 'Hide Stack Trace' : 'Show Stack Trace'}
          </Button>
          {showStack && <pre style={{ color: 'red' }}>{errorStack}</pre>}
        </>
      )}
    </Alert>
  );
};

export default FallbackRender;
